import { DateTime } from 'luxon'

export const isComingDue = (unit) => unit?.attributes['due-in'] - unit?.attributes['days-floored'] < 7

export const isPastDue = (unit) => unit?.attributes['days-floored'] > unit?.attributes['due-in']

export const soldUnitDueDate = (unit) => DateTime.fromFormat(unit?.attributes['sold-on'], 'MM/dd/yyyy').plus({ days: 10 }).toFormat('ccc M/d')

export const dueOn = (unit) => DateTime.fromISO(unit.attributes['due-on']).toFormat('ccc M/d')

export const isArbitrated = (unit) => Number(unit?.attributes['sold-enum']) === 4

export const isReviewDue = (lastReviewDate) => {
  return lastReviewDate && DateTime.now() > DateTime.fromISO(lastReviewDate).plus({ years: 1 })
}

export const lastSix = (vin) => vin.slice(-6)

export const isUnitAndDateMatch = (amountDueOn, unitId) => {
  // Checks if unit id matches the unit id in amountDueOn and the date in amountDueOn is today
  return(
    amountDueOn.id === Number(unitId) &&
    new Date(amountDueOn['amounts_due_on_date']).setHours(0,0,0,0) === new Date().setHours(0,0,0,0)
  )
}

export const isUnitMatch = (amountDueOn, unitId) => {
  // Checks if unit id matches the unit id in amountDueOn
  return(
    amountDueOn.id === Number(unitId)
  )
}